/* assets/b2b-cart.js
   - AJAX add-to-cart (no redirect)
   - Cart count updates in header (Panier (X))
   - Supports variant dropdown on collection tiles
   - Toast feedback
*/

(function () {
  function setCartCount(count) {
    document.querySelectorAll(".b2b-cart-count").forEach(function (el) {
      el.textContent = "(" + String(count) + ")";
    });
  }

  async function refreshCartCount() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      const cart = await res.json();
      setCartCount(cart.item_count || 0);
    } catch (e) {
      // silent
    }
  }

  function showToast(message) {
    let t = document.getElementById("b2bToast");
    if (!t) {
      t = document.createElement("div");
      t.id = "b2bToast";
      t.className = "b2b-toast";
      document.body.appendChild(t);
    }
    t.textContent = message;
    t.classList.add("is-visible");
    clearTimeout(window.__b2bToastTimer);
    window.__b2bToastTimer = setTimeout(function () {
      t.classList.remove("is-visible");
    }, 1600);
  }

  async function addToCart(variantId, qty, btn) {
    if (!variantId) return;

    const originalText = btn ? btn.textContent : "";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Ajout…";
    }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Number(qty || 1),
        }),
      });

      if (!res.ok) {
        // Shopify renvoie souvent un JSON avec un message, mais on reste simple.
        showToast("Impossible d’ajouter (variante indisponible)");
      } else {
        await refreshCartCount();
        showToast("Ajouté au panier");
      }
    } catch (e) {
      showToast("Erreur — réessaie");
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  }

  // Active/désactive le bouton selon le dropdown variante
  document.addEventListener("change", function (e) {
    const select = e.target.closest(".b2b-variant-select");
    if (!select) return;

    const tile = select.closest(".b2b-product");
    if (!tile) return;

    const btn = tile.querySelector("[data-b2b-add]");
    if (!btn) return;

    // Si une valeur est choisie, on active le bouton.
    btn.disabled = !select.value;
  });

  // Clic sur "Ajouter au panier" (tuiles collection OU ailleurs)
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-b2b-add]");
    if (!btn) return;

    e.preventDefault();

    // 1) cas simple : le bouton a déjà data-variant-id
    let variantId = btn.getAttribute("data-variant-id");

    // 2) sinon : on va chercher la valeur du dropdown dans la tuile
    if (!variantId) {
      const tile = btn.closest(".b2b-product");
      const select = tile && tile.querySelector(".b2b-variant-select");
      if (select) variantId = select.value;
    }

    if (!variantId) {
      showToast("format");
      return;
    }

    const qty = btn.getAttribute("data-qty") || "1";
    addToCart(variantId, qty, btn);
  });

  // Au chargement : sync compteur panier
  document.addEventListener("DOMContentLoaded", function () {
    refreshCartCount();
  });
})();